<div class="d-flex sticky-parent-container">
  @if (
    {
      showOnlyQualifiedStaff:
        timelineModalFilterService.showOnlyQualifiedStaff$ | async,
      displayQualifiedWorkingTimeStaff:
        timelineModalFilterService.displayQualifiedWorkingTimeStaff$ | async,
      staffAvailability: timelineModalFilterService.staffAvailability$ | async,
    };
    as data
  ) {
    <div class="sticky-box p-2">
      @if (
        data.displayQualifiedWorkingTimeStaff ||
        data.showOnlyQualifiedStaff ||
        data.staffAvailability !== AssignmentAvailabilityStatus.NotAvailable
      ) {
        <div>
          <div class="fw-normal text-dark filter-header">
            {{
              'page.shift_timeline.find_staff_modal.show_more.title' | translate
            }}
          </div>
          <div class="mb-2">
            {{
              'page.shift_timeline.find_staff_modal.show_more.description'
                | translate
            }}
          </div>
          <div class="d-flex filter-option">
            <button
              (click)="staffAvailabilityChanged()"
              nzBlock
              nz-button
              nzType="default"
              [disabled]="
                data.staffAvailability ===
                AssignmentAvailabilityStatus.NotAvailable
              "
              type="button"
              class="fw-normal w-100"
            >
              {{
                data.staffAvailability ===
                AssignmentAvailabilityStatus.Available
                  ? ('page.shift_timeline.find_staff_modal.show_more.set_filter_to_partly'
                    | translate)
                  : ('page.shift_timeline.find_staff_modal.show_more.set_filter_to_not_available'
                    | translate)
              }}
            </button>
            <wilson-filter-qualified-staff-changed-button
              [disabled]="!data.showOnlyQualifiedStaff"
            ></wilson-filter-qualified-staff-changed-button>
            <wilson-filter-qualified-working-time-staff-changed-button
              style="margin-left: 0.5rem"
              [disabled]="!data.displayQualifiedWorkingTimeStaff"
            ></wilson-filter-qualified-working-time-staff-changed-button>
          </div>
        </div>
      }
    </div>
  }
</div>
